import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ModerationTransitions extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId, statusId }) {
        if (!flowId && !statusId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/transitions`;
        }

        if (!flowId && statusId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/status/${statusId}/transitions`;
        }

        if (flowId && !statusId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transitions`;
        }

        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/status/${statusId}/transitions`;
    }

    toOption(flow = null) {
        const name = this.name || `${this.source_status.name} > ${this.destination_status.name}`;
        return {
            key: this.id,
            text: flow ? `${flow} - ${name}` : name,
            value: this.id
        };
    }
}

export class ModerationTransitionValidation extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId, transitionId }) {
        if (!flowId && !transitionId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/transition_validations`;
        }

        if (!flowId && transitionId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/transitions/${transitionId}/transition_validations`;
        }

        if (flowId && !transitionId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transition_validations`;
        }

        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transitions/${transitionId}/transition_validations`;
    }

    toOption() {
        return {
            key: this.id,
            text: this.label,
            value: this.id
        };
    }
}

export class AttendeeModerationTransitions extends ModerationTransitions {
    static listUrl({ organizationId, flowId, attendeeId }) {
        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/attendees/${attendeeId}/transitions`;
        }

        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/attendees/${attendeeId}/transitions`;
    }
}
